

const RateBox = ({rateTitle,rate,rateDate,rateIcon}) => {

    return ( <> 
    <div className="rateBox">

        <span className="font-IRANYekanExtra text-[17px] text-black lg:text-[12px]">
            {rateTitle}
        </span>
        <div className="flex flex-col items-center w-[80px]">
            <span className="font-IRANYekanBold text-[19px] text-black lg:text-[14px]">
                {rate}
            </span>
            <p className="font-IRANYekanMedium text-[11px] text-mainColor2 lg:text-[9px]">
                {rateDate}
            </p>
           {/* {rateIcon} */}
        </div>

    </div> </>
    )
}

export default RateBox;